import { createContext } from 'react';

// ---------------- Context Types & Hook ----------------
export interface FiltersContextValue {
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
}

export const FiltersContext = createContext<FiltersContextValue | null>(null);
